// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"159":"56c215ed62d45b1339e7","339":"cbcc48fd1ce1a3abc16c"}[chunkId] + ".js";
};